import { ReactNode } from 'react'
import { Box, Container } from '@chakra-ui/react'
import { Header } from './Header'
import { Footer } from './Footer'

interface PageContainerProps {
  children: ReactNode
  maxW?: string
  fullWidth?: boolean
  hideFooter?: boolean
  hideHeader?: boolean
  hideUserMenu?: boolean
  headerCenterContent?: ReactNode
  noPadding?: boolean
}

export function PageContainer({
  children,
  maxW = '6xl',
  fullWidth = false,
  hideFooter = false,
  hideHeader = false,
  hideUserMenu,
  headerCenterContent,
  noPadding = false,
}: PageContainerProps) {
  // Hide user menu in header when fullWidth (sidebar has it)
  const shouldHideUserMenu = hideUserMenu ?? fullWidth

  // Full-width pages (editor) use fixed layout with no page scroll
  // Standard pages use native browser scroll
  if (fullWidth) {
    return (
      <Box className="fixed-layout" display="flex" flexDirection="column">
        {!hideHeader && <Header hideUserMenu={shouldHideUserMenu} centerContent={headerCenterContent} />}
        <Box as="main" flex="1" display="flex" flexDirection="column" overflow="hidden" minH={0} mt={!hideHeader ? '56px' : 0}>
          {children}
        </Box>
        {!hideFooter && <Footer />}
      </Box>
    )
  }

  // For pages like landing page that need edge-to-edge content
  // No padding needed - hero section handles its own layout
  if (noPadding) {
    return (
      <Box minH="100vh" display="flex" flexDirection="column" overflowX="hidden">
        <Header hideUserMenu={shouldHideUserMenu} centerContent={headerCenterContent} />
        <Box as="main" flex="1">
          {children}
        </Box>
        {!hideFooter && <Footer />}
      </Box>
    )
  }

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header hideUserMenu={shouldHideUserMenu} centerContent={headerCenterContent} />
      <Container as="main" flex="1" maxW={maxW} py={6} px={4} mt="56px">
        {children}
      </Container>
      {!hideFooter && <Footer />}
    </Box>
  )
}
